// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
// Keep the mounted-mesh renderer and its source out of the initial browser graph.
import type {MachineToy} from '@core/machine'
let implementation: typeof import('./salvageMechanismMesh') | undefined
export async function prepareSalvageMechanisms():Promise<void>{
  implementation ??= await import('./salvageMechanismMesh')
  await implementation.prepareSalvageMechanisms()
}
export function buildSalvageMechanism(toy:MachineToy){
  if(implementation===undefined)throw Error('Mounted mechanism renderer has not been prepared')
  return implementation.buildSalvageMechanism(toy)
}
